import { createBrowserRouter, Navigate, RouterProvider, useParams } from "react-router-dom";
import HomePageOne from "./pages/HomePageOne";
import PrivateRoute from "./components/PrivateRoute";
import SignInPage from "./pages/signIn/SignInPage";
import PoliticaPrivacidad from "./pages/legal/PoliticaPrivacidad";
import PasswordActionPage from "./pages/auth/PasswordActionPage";

import Sucursales from "./pages/sucursal/Sucursales";
import DetalleSucursal from "./pages/sucursal/DetalleSucursal";

import Usuarios from "./pages/usuarios/Usuarios";
import DetalleUsuario from "./pages/usuarios/DetalleUsuarios";

import CategoriasPlatilloPage from "./pages/menu/categorias/CategoriasPlatillo";
import DetalleCategoriasPlatillo from "./pages/menu/categorias/DetalleCategoriasPlatillo";

import PlatillosPage from "./pages/menu/platillos/Platillos";
import DetallePlatillo from "./pages/menu/platillos/DetallePlatillo";

import Promociones from "./pages/promociones/Promociones";
import DetallePromocion from "./pages/promociones/DetallePromocion";

import Preferencias from "./pages/preferencias/Preferencias";
import DetallePreferencia from "./pages/preferencias/DetallePreferencia";

import Clientes from "./pages/clientes/Clientes";

import Top from "./pages/top/Top";
import CategoriaOrden from "./pages/categoria_orden/CategoriaOrden";

import Reservaciones from "./pages/reservaciones/Reservaciones";

import Notificaciones from "./pages/notificaciones/Notificaciones";
import DetalleNotificaciones from "./pages/notificaciones/DetalleNotificaciones";

import Torneos from "./pages/torneos/Torneos";
import DetalleTorneo from "./pages/torneos/DetalleTorneo";

import Canchas from "./pages/canchas/Canchas";
import DetalleCancha from "./pages/canchas/DetalleCancha";
import TarifasCanchas from "./pages/canchas/TarifasCanchas";

import Calendario from "./pages/calendario/Calendario";
import AprobarPartidas from "./pages/aprobarPartidas/AprobarPartidas";
import PaseListaPartidas from "./pages/paseLista/PaseListaPartidas";

import ErrorPage from "./pages/ErrorPage";
import RouteScrollToTop from "./helper/RouteScrollToTop";
import { AuthProvider } from "./auth/AuthProvider";

const RedirectToCategoriaMerch = () => {
  const { id } = useParams();
  return <Navigate to={`/categoria-merch/${id}`} replace />;
};

const RedirectToMerch = () => {
  const { id } = useParams();
  return <Navigate to={`/merch/${id}`} replace />;
};

const router = createBrowserRouter([
  {
    path: "/login",
    element: <SignInPage />,
  },
  {
    path: "/set-password",
    element: <PasswordActionPage action="set" />,
  },
  {
    path: "/reset-password",
    element: <PasswordActionPage action="reset" />,
  },
  {
    path: "/politica-privacidad",
    element: <PoliticaPrivacidad />,
  },
  {
    path: "/politicas-y-privacidad",
    element: <Navigate to="/politica-privacidad" replace />,
  },
  {
    
    element:<PrivateRoute />,
    children: [
      {
        path: "/",
        element: <HomePageOne />,
      },
      {
        path: "/sucursales",
        element:<Sucursales />,
      },
      {
        path: "/sucursal/:id",
        element:<DetalleSucursal />,
      },
      {
        path: "/usuarios",
        element:<Usuarios />,
      },
      {
        path: "/usuario/:id",
        element: <DetalleUsuario />,
      },
      {
        path: "/categorias-merch",
        element:<CategoriasPlatilloPage />,
      },
      {
        path: "/categoria-merch/:id",
        element: <DetalleCategoriasPlatillo />,
      },
      {
        path: "/merch",
        element:<PlatillosPage />,
      },
      {
        path: "/merch/:id",
        element: <DetallePlatillo />,
      },
      {
        path: "/categorias-menu",
        element:<Navigate to="/categorias-merch" replace />,
      },
      {
        path: "/categoria_platillo/:id",
        element: <RedirectToCategoriaMerch />,
      },
      {
        path: "/platillos",
        element:<Navigate to="/merch" replace />,
      },
      {
        path: "/platillo/:id",
        element: <RedirectToMerch />,
      },
      {
        path: "/promociones",
        element: <Promociones />,
      },
      {
        path: "/promocion/:id",
        element: <DetallePromocion />,
      },
      {
        path: "/preferencias",
        element:<Preferencias />,
      },
      {
        path: "/preferencia/:id",
        element:<DetallePreferencia />,
      },
      {
        path: "clientes",
        element:<Clientes />,
      },
      {
        path: "top",
        element:<Top />,
      },
      {
        path: "categoria_orden",
        element:<CategoriaOrden />,
      },
      {
        path: "reservaciones",
        element:<Reservaciones />,
      },
      {
        path: "notificaciones",
        element:<Notificaciones />,
      },
      {
        path: "notificacion/:id",
        element:<DetalleNotificaciones />,
      },
      {
        path: "torneos",
        element:<Torneos />,
      },
      {
        path: "torneo/:id",
        element:<DetalleTorneo />,
      },
      {
        path: "canchas",
        element:<Canchas />,
      },
      {
        path: "cancha/:id",
        element:<DetalleCancha />,
      },
      {
        path: "tarifas-canchas",
        element:<TarifasCanchas />,
      },
      {
        path: "calendario",
        element:<Calendario />,
      },
      {
        path: "aprobar-partidas",
        element:<AprobarPartidas />,
      },
      {
        path: "pase-lista-partidas",
        element:<PaseListaPartidas />,
      },
      {
        path: "*",
        element: <ErrorPage />,
      },
    ]
  },
]);

function App() {
  return (
    <>
    <AuthProvider>
        <RouterProvider router={router}><RouteScrollToTop /></RouterProvider>
      </AuthProvider>
    </>
  );
}

export default App;
